/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React from "react";
import Icon from "../GlobalComponents/Icon";
import GymTitle from "./Title";
import GymSubtitle from "./Subtitle";
import GymProgramCard from "./Card";
import Container from "../GlobalComponents/Container";

const GymProgram = () => (
  <div css={styles} className="gymProgram">
    <GymTitle />
    <Icon />
    <GymSubtitle />
    <Container>
      <GymProgramCard
        title="Summer Camps"
        desc="Summer Camps are held at UMT ACM"
      />
      <GymProgramCard
        title="Competitions"
        desc="Descriptions about Competitions"
      />
      <GymProgramCard
        title="Events"
        desc="Description for some events"
      />
      <GymProgramCard
        title="Seminars"
        desc="Description for seminars"
      />
      <GymProgramCard
        title="Workshops"
        desc="Description for workshops"
      />

    </Container>
  </div>
);

const styles = css`
  width: 100%;
  min-height: 100vh;
  text-align: center;
  padding: 120px 0;
  .container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 40px 0;
  }
  @media (max-width: 700px) {
    .container {
      flex-direction: column;
      justify-content: flex-start;
    }
  }
  @media (min-width: 701px) and (max-width: 1100px) {
    .container {
      flex-direction: column;
      align-items: center;
    }
  }
`;

export default GymProgram;
